module.exports = __webpack_public_path__ + "static/img/get-in-touch.27a5ce1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/get-in-touch.jpg
// module id = ZQMV
// module chunks = 1